import { get } from './../Config/config';


export const TriageLeadsAPI = {
    get: (data) => get('/triages', { params: data }),
    save: (data) => get('/triages-save-to-lead', { params: data }),
    details: (data) => get(`/triage/${data.id}`),
}

